// O logotipo do Truco de 6 nos apps em React (jogo e admin). O arquivo sai do marca.json (escolher-marca.ts): o
// horizontal ou o símbolo, para fundo escuro ou claro. Sempre com width, height, alt="Truco de 6" e o respiro em volta.
// Com `inicio`, a marca é o link para o início, com o nome "Truco de 6, início". O respiro também vai em --respiro,
// para a tela alinhar a imagem ao texto com uma margem negativa do mesmo tamanho.
import type { CSSProperties } from 'react';
import horizontalClaro from '../marca/svg/truco-de-6-fundo-claro.svg?url';
import horizontalEscuro from '../marca/svg/truco-de-6-fundo-escuro.svg?url';
import simbolo from '../marca/svg/truco-de-6-simbolo.svg?url';
import { ALT_DA_MARCA, NOME_DO_LINK_DA_MARCA, escolherMarca, type FundoDaMarca, type VarianteDaMarca } from './escolher-marca.ts';

export const ENDERECO_DA_MARCA: Readonly<Record<string, string>> = {
  'svg/truco-de-6-fundo-escuro.svg': horizontalEscuro,
  'svg/truco-de-6-fundo-claro.svg': horizontalClaro,
  'svg/truco-de-6-simbolo.svg': simbolo,
};

export function Marca({ variante = 'horizontal', fundo = 'escuro', altura, inicio, className }: {
  variante?: VarianteDaMarca; fundo?: FundoDaMarca; altura: number; inicio?: string; className?: string;
}) {
  const m = escolherMarca(variante, fundo, altura);
  const img = <img src={ENDERECO_DA_MARCA[m.arquivo]} alt={ALT_DA_MARCA} width={m.largura} height={m.altura} />;
  const props = { className: 'marca' + (className ? ' ' + className : ''), style: { padding: m.respiro, '--respiro': m.respiro + 'px' } as CSSProperties };
  return inicio ? <a {...props} href={inicio} aria-label={NOME_DO_LINK_DA_MARCA}>{img}</a> : <span {...props}>{img}</span>;
}
